import React from 'react';
import { Search, Menu, ShoppingBag, Phone } from 'lucide-react';
import { Link } from 'react-router-dom';
import { Input } from './ui/input';
import { Button } from './ui/button';

interface HeaderProps {
  onMenuToggle: () => void;
  onSearchToggle: () => void;
  onContactClick: () => void;
}

export function Header({ onMenuToggle, onSearchToggle, onContactClick }: HeaderProps) {
  return (
    <header className="sticky top-0 z-50 bg-brand-green border-b border-brand-green/20 shadow-md">
      <div className="relative flex h-24 sm:h-28 items-center px-4">
        {/* Menu (Left) */}
        <Button
          variant="ghost"
          size="icon"
          className="text-white hover:bg-white/10 z-10 mr-2"
          onClick={onMenuToggle}
        >
          <Menu className="h-6 w-6" />
          <span className="sr-only">Toggle menu</span>
        </Button>

        {/* Logo Section */}
        <div className="flex-1 flex items-center justify-start z-10 ml-0 sm:ml-2">
            <Link to="/" className="flex items-center space-x-1 transition-all duration-300 hover:opacity-90 group">
                <div className="relative flex items-center">
                    <img
                        src="/rpk-logo.png"
                        alt="RPK Logo"
                        className="h-16 sm:h-22 lg:h-24 w-auto object-contain drop-shadow-2xl transition-transform duration-300 group-hover:scale-105"
                    />
                </div>
                <div className="flex flex-col justify-center border-l border-[#DBC67C]/30 pl-1.5 py-1">
                    <span className="text-sm sm:text-base lg:text-xl font-light tracking-[0.1em] text-[#DBC67C] leading-tight uppercase font-serif">
                        Ram Pratap Katta
                    </span>
                    <span className="text-[10px] sm:text-xs lg:text-sm font-light tracking-[0.25em] text-[#DBC67C] leading-none uppercase font-serif mt-1">
                        & Sons Saraf
                    </span>
                </div>
            </Link>
        </div>

        {/* Search & Contact (Right) */}
        <div className="flex items-center space-x-1 sm:space-x-2 z-10">
            <Button 
                variant="ghost" 
                size="icon" 
                className="text-white hover:bg-white/10"
                onClick={onContactClick}
            >
                <Phone className="h-5 w-5 sm:h-6 sm:w-6" />
                <span className="sr-only">Contact Us</span>
            </Button>

            <Button 
                variant="ghost" 
                size="icon" 
                className="text-white hover:bg-white/10"
                onClick={onSearchToggle}
            >
                <Search className="h-5 w-5 sm:h-6 sm:w-6" />
                <span className="sr-only">Toggle search</span>
            </Button>
        </div>
      </div>
    </header>
  );
}